module.exports = __webpack_public_path__ + "media/images/about-us-img-02-3aba0cdec320a294d659cd8b9e2f5e1a.png";